const MessageModal = ({
  open,
  title,
  message,
  onClose,
  confirmOnly = false,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-30">
      <div className="bg-white shadow-xl rounded-lg px-8 py-12 w-full max-w-md text-center border border-[#6F81F5] relative">
        {!confirmOnly && (
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-gray-500 hover:text-black"
          >
            <img src="/icons/cross.svg" alt="Close" className="w-6 h-6" />
          </button>
        )}

        <h2 className="text-lg font-semibold mb-4 text-indigo-600">{title}</h2>
        <p className="text-gray-800 mb-6">{message}</p>

        <div className="flex justify-center gap-4">
          {confirmOnly ? (
            <>
              <button
                onClick={() => onConfirm && onConfirm()}
                className="px-6 py-2 bg-red-500 text-white rounded-md"
              >
                Delete
              </button>
              <button
                onClick={onClose}
                className="px-6 py-2 bg-gray-300 text-gray-800 rounded-md"
              >
                Cancel
              </button>
            </>
          ) : (
            <button
              onClick={onClose}
              className="px-6 py-2 bg-blue-500 text-white rounded-md"
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
